import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRushBusy = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 1C2.89543 1 2 1.89543 2 3C2 4.10457 2.89543 5 4 5C5.10457 5 6 4.10457 6 3C6 1.89543 5.10457 1 4 1ZM3 3C3 3.55228 3.44772 4 4 4C4.55228 4 5 3.55228 5 3C5 2.44772 4.55228 2 4 2C3.44772 2 3 2.44772 3 3Z'
    />
    <path d='M12 6.5C12 6.22386 12.2239 6 12.5 6C13.8807 6 15 7.11929 15 8.5V10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5V8.5C14 7.67157 13.3284 7 12.5 7C12.2239 7 12 6.77614 12 6.5Z' />
    <path d='M13.5 15C13.7761 15 14 14.7761 14 14.5V11H13V14.5C13 14.7761 13.2239 15 13.5 15Z' />
    <path d='M2.5 15C2.77614 15 3 14.7761 3 14.5V11H2V14.5C2 14.7761 2.22386 15 2.5 15Z' />
    <path d='M5.5 15C5.77614 15 6 14.7761 6 14.5V11H5V14.5C5 14.7761 5.22386 15 5.5 15Z' />
    <path d='M9.5 15C9.77614 15 10 14.7761 10 14.5V11H9V14.5C9 14.7761 9.22386 15 9.5 15Z' />
    <path d='M3.5 7C2.67157 7 2 7.67157 2 8.5V10.5C2 10.7761 1.77614 11 1.5 11C1.22386 11 1 10.7761 1 10.5V8.5C1 7.11929 2.11929 6 3.5 6H4.5C5.88071 6 7 7.11929 7 8.5V10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5V8.5C6 7.67157 5.32843 7 4.5 7H3.5Z' />
    <path d='M8 6.5C8 6.22386 8.22386 6 8.5 6C9.88071 6 11 7.11929 11 8.5V10.5C11 10.7761 10.7761 11 10.5 11C10.2239 11 10 10.7761 10 10.5V8.5C10 7.67157 9.32843 7 8.5 7C8.22386 7 8 6.77614 8 6.5Z' />
    <path d='M8 5C9.10457 5 10 4.10457 10 3C10 1.89543 9.10457 1 8 1V2C8.55228 2 9 2.44772 9 3C9 3.55228 8.55228 4 8 4V5Z' />
    <path d='M12 5C13.1046 5 14 4.10457 14 3C14 1.89543 13.1046 1 12 1V2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4V5Z' />
  </svg>
);
export default SvgRushBusy;
